import { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { DotSpinner } from '@crono-one/design-system';

import PATH from 'crono-fe-common/constants/path';
import {
  buildDynamicsDiscoveryLoginUrl,
  DYNAMICS_RETURN_PATH_PARAM,
} from 'hooks/services/dynamics/dynamicsOauthState';

/**
 * Entry point for a Dynamics connect started on another origin (local
 * development): mints the state nonce on this origin, which is where Microsoft
 * redirects back to, then hands off to sign-in 1.
 */
const DynamicsLoginStart: FC = () => {
  const { search } = useLocation();

  useEffect(() => {
    const returnPath =
      new URLSearchParams(search).get(DYNAMICS_RETURN_PATH_PARAM) ??
      PATH.SETTINGS.INTEGRATIONS.MAIN;
    window.location.replace(buildDynamicsDiscoveryLoginUrl(returnPath));
  }, [search]);

  return (
    <div className="flex h-full w-full items-center justify-center">
      <DotSpinner />
    </div>
  );
};

export default DynamicsLoginStart;
